<div class="root-container">
  @if (role.name == 'customer') {
    <div class="customer">
      <customer-header/>
      <div class="content scrollbars">
        <div style="flex:1;">
          <div class="container">
            <customer-profile/>
          </div>
        </div>
        <public-footer />
      </div>
    </div>
  }
  @else {
    <div class="internal">
      <internal-sidebar
        #sidebar
        [role]="role.title"
        [links]="navLinks"
        class="sidebar"
        tabindex="0"/>
      <div class="main">
        <common-header  />
          <div class="content scrollbars">
              <div class="container">
                <internal-profile />
              </div>
          </div>
        <common-footer />
      </div>
    </div>
  }
  <toast #toast/>
  <modals #modals/>
</div>
